import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { toast } from 'react-toastify';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';

export const RetryP1DocumentButton: React.FC<{
  documentId: string;
  onSuccess?: () => void;
}> = ({ documentId, onSuccess }) => {
  const spd = useSpdCore();

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await spd.judgmentP1Documents.retry(documentId);
      toast.success('Wysyłka orzeczenia została ponowiona');
      onSuccess?.();
    } catch (response) {
      const errors = await responseErrors(response as ResponseError);
      alert('Błąd ponowienia wysyłki:\n' + errors);
    }
  };

  return (
    <OverlayTrigger overlay={<Tooltip>Ponów wysyłkę</Tooltip>}>
      <Button onClick={handleClick} variant="btn-info">
        <Icon.ArrowRepeat />
      </Button>
    </OverlayTrigger>
  );
};
